import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './expediente.css';
import { selectAuthenticated, selectUser } from '../auth/authSlice';
import { STATUS, loadExpediente } from './expedienteSlice';
import Login from '../auth/Login';
import Spinner from '../../components/Spinner';
import Actuaciones from './actuacion/Actuaciones';

export default function VerExpediente () {
    const navigate = useNavigate();
    const userAuthenticated = useSelector(selectAuthenticated);
    const user = useSelector(selectUser);
    /* useEffect(() => {
        if (!userAuthenticated) {
            navigate('/login');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAuthenticated]); */

    const { num } = useParams();
    const dispatch = useDispatch();
    const { expediente, status, error } = useSelector((state) => state.expediente);

    useEffect(()=>{
        if (!isNaN(parseInt(num))) {
            dispatch(loadExpediente(num));
        } else {
            alert('Es necesario el número de expediente.');
            navigate('/');
        }
    }, [num]);

    if (!userAuthenticated) {
        return <Login />;
    }

    if (status === STATUS.LOADING) {
        return <Spinner/>;
    }

    if (error === STATUS.COULDNT_LOAD) {
        return (
            <> 
                <div className='title'>
                    <h2>ERROR: No hay ningún expediente nº {num}</h2>
                </div>
                <button id='volver' onClick={() => navigate('/')}>Volver a inicio</button>
            </>
        );
    }

    return (
        <> 
            <div className='title'>
                <h2>Expediente nº {num}</h2>
                <h3>Estado: 
                    { expediente.abierto 
                        ? ' Abierto'
                        : ' Cerrado' 
                    }
                </h3>
            </div>
            <button id="volver" onClick={() => navigate(-1)}>Atrás</button>

            <div className="buttons-fullpage">
                {expediente.abierto && <button onClick={() => navigate(`/expediente/${num}/editar`)}>Editar</button>}
            </div>
            <div className='content'>
                <form>
                    <h3>Datos de registro:</h3>
                    <label htmlFor="escenario">Escenario:</label>
                    <input readOnly type="text" id="escenario" name="escenario" value={expediente.escenario || ''}/>
                    <label htmlFor="plataforma">Plataforma:</label>
                    <input readOnly type="text" id="plataforma" name="plataforma" value={expediente.plataforma}/>    
                    <label htmlFor="responsable">Responsable de la plataforma / sistema de protección:</label>
                    <input readOnly type="text" id="responsable" name="responsable" value={expediente.responsable}/>
                    <label htmlFor="fecha_apertura">Fecha de apertura:</label>
                    <input readOnly type="date" id="fecha_apertura" name="fecha_apertura" value={expediente.fecha_apertura}/>
                    {expediente.cierre?.fecha_cierre 
                        ? <>
                            <label htmlFor="fecha_cierre">Fecha de cierre:</label>
                            <input readOnly type="date" id="fecha_cierre" name="fecha_cierre" value={expediente.cierre?.fecha_cierre}/>
                    
                        </>
                        : ''
                    }
                    <h3>Registro de actuaciones:</h3>
                    <Actuaciones editable={false}/>            
                    
                    <h3>Resultados:</h3>
                    <label htmlFor="medidas">Medidas adoptadas:</label>
                    { expediente.medidas.length > 0
                        ? expediente.medidas?.map((m, index) => (
                            <div key={index}>
                                <div className='textarea-content'>
                                    <pre>{`${m.texto_medida}`}</pre>
                            
                                </div>
                                {m.escrito_por
                                    ? <p className='author'>{`-- Escrito por ${m.escrito_por}`}</p>
                                    : ''
                                }
                            </div>
                        ))
                        : <input readOnly type="text" id="medidas" name="medidas" value=""/>
                    }
                
                    <label htmlFor="resultados">Resultados de las medidas:</label>
                    { expediente.resultados.length > 0
                        ? expediente.resultados?.map((r, index) => (
                            <div key={index}>
                                <div className='textarea-content'>
                                    <pre>{`${r.texto_resultado}`}</pre>
                            
                                </div>
                                {r.escrito_por
                                    ? <p className='author'>{`-- Escrito por ${r.escrito_por}`}</p>
                                    : ''
                                }
                            </div>
                        ))
                        : <input readOnly type="text" id="resultados" name="resultados" value=""/>
                    }
                    { user.responsable_spiyv && <div>
                        <h3>Cierre:</h3>
                        <label htmlFor="cierre.motivo_cierre">Motivo de cierre del expediente:</label>
                        <input readOnly type="text" id="cierre.motivo_cierre" name="cierre.motivo_cierre" value={expediente.cierre?.motivo_cierre || ''}/>
                        {expediente.cierre?.detalle_otras_medidas ?
                            <div>
                                <label htmlFor="cierre.detalle_otras_medidas">Más detalles:</label>
                                <div className='textarea-content'>
                                    <pre>{expediente.cierre.detalle_otras_medidas}</pre>
                                </div>
                            </div>
                            :
                            ''
                        }
                        <label htmlFor="cierre.motivo_cierre">Notificado a entidad pública: <strong>{expediente.cierre?.notificado_a_entidad_publica ? 'SÍ' : 'NO' }</strong></label>
                        <div>&nbsp;</div>
                        <label htmlFor="fecha_medida">Fecha de la medida que origina la propuesta de cierre:</label>
                        <input readOnly type="date" id="fecha_medida" name="fecha_medida" value={expediente.cierre?.fecha_medida || ''}/>
                        <label htmlFor="dias_apertura_medida">Días desde la apertura a la medida tomada:</label>
                        <input readOnly type="text" id="dias_apertura_medida" name="dias_apertura_medida" value={expediente.cierre?.dias_apertura_medida || ''}/>
                        <label htmlFor="fecha_cierre">Fecha de cierre:</label>
                        <input readOnly type="date" id="fecha_cierre" name="fecha_cierre" value={expediente.cierre?.fecha_cierre || ''}/>
                    
                        <h3>Responsable del expediente:</h3>
                        <label htmlFor="nombre_responsable">Nombre:</label>
                        <input readOnly type="text" id="nombre_responsable" name="nombre_responsable" 
                            value={expediente.cierre?.nombre_responsable}/>
                        <label htmlFor="funcion_responsable">Función dentro del SdPI:</label>
                        <input readOnly type="text" id="funcion_responsable" name="funcion_responsable" 
                            value={expediente.cierre?.funcion_responsable}/>

                        <h3>Clasificación estadística:</h3>
                        <label htmlFor="clasificacion.tipo_violencia">Tipo de violencia:</label>
                        <input readOnly type="text" id="clasificacion.tipo_violencia" name="clasificacion.tipo_violencia" value={expediente.clasificacion?.tipo_violencia || ''}/>
                        <label htmlFor="clasificacion.ambito">Ámbito:</label>
                        <input readOnly type="text" id="clasificacion.ambito" name="clasificacion.ambito" value={expediente.clasificacion?.ambito || ''}/>
                        <label htmlFor="clasificacion.edad_persona_vulnerable">Edad de la persona vulnerable:</label>
                        <input readOnly type="text" id="clasificacion.edad_persona_vulnerable" name="clasificacion.edad_persona_vulnerable" 
                            value={expediente.clasificacion?.edad_persona_vulnerable ? expediente.clasificacion?.edad_persona_vulnerable : ''}/>
                        <label htmlFor="clasificacion.sexo_persona_vulnerable">Sexo de la persona vulnerable:</label>
                        <input readOnly type="text" id="clasificacion.sexo_persona_vulnerable" name="clasificacion.sexo_persona_vulnerable" 
                            value={expediente.clasificacion?.sexo_persona_vulnerable ? expediente.clasificacion?.sexo_persona_vulnerable : ''}/>
                    </div>
                    }
                </form>
            </div>
            <button onClick={() => navigate(-1)}>Atrás</button>
        </>
    );
}